import React, { Component } from 'react';


class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
    };
  }

  async componentDidMount() {

  }


  render() {
    return (
      <div className="container margin-top-100">
        <h3 className='bold-font blackColor mb-4'>About Us</h3>
        <p className='light-font para'>We’re equally passionate about consumers, the private and public sectors.</p>
        <p className='light-font para'>rate.repeat.review (R3) is the Pacific’s first consumer review and opinion site.  Built by Islanders for Islanders. We are a review and rating platform, collaborative and open to all. As the name says - users can rate and review (and repeat) about services and products as well as about the business or organisation that sell or provide them. </p>
        <p className='light-font para'>Our definition of the “consumer” is broad because we believe a consumer is anyone who accesses and/or buys any service or product from an organisation in the private or public sector.</p>
        <p className='light-font para'>R3 is based on our ethos and ideology which seek to ensure that consumers are accorded duty of care, protection, and the level of respect they deserve which they purchase a service or product, and in return, private and public sector entities are rewarded with due acknowledgement and recognition of providing the subsequent service or product. </p>
        <p className='light-font para'>We are an endless driver for innovation, empowerment, safe choices, better service delivery, product improvement, and consumer driven progress in real time based on real life experiences. </p>
        <p className='light-font para'>R3 provides consumers a community of safety and security like no other and is a tool that generates leads or identifies gaps for improvement for entities based on feedback received from consumers.</p>
        <p className='light-font para'>No matter whatever language you say it in, how you say it, write it, or pronounce it – we provide you a place to tell your story, in your voice. So, let’s hear it!  </p>

        {/* <span className='bold-semifont para mt-2'>We’re equally passionate about </span> */}
       

      
      </div>

    )
  }
}

export default About;